<template>
    <div>
        <b-form-group>
            <label for="" class="label-service-type">Service Type</label>
            <div class="custom_service_type">
                {{ service_types.filter(item=> item.id.toString() === service_type)[0].name}}
            </div>
        </b-form-group>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Select2 from "v-select2-component";
import { BFormGroup } from "bootstrap-vue";
export default {
    components: {
        Select2,
        BFormGroup,
    },
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        readonlyService: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
        },
    },
    computed: {
        service_type: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                this.$emit("input", value);
            },
        },
        ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
        ]),
    },
};
</script>

<style lang="scss">
.label-service-type {
    font-size: 1.5rem;
    font-weight: 600;
    color: #28938d;
    margin-bottom: 10px;
    display: block;
}
.form-control-select-custom {
    width: 200px;
    .select2-container--default .select2-selection--single {
        background-color: #28938d !important;
        .select2-selection__placeholder {
            color: #ffffffb7 !important;
        }
        .select2-selection__rendered {
            color: #fff !important;
        }
    }
    .select2-selection--single:before {
        content: "";
        position: absolute;
        right: 14px;
        top: 0;
        bottom: 0;
        width: 14px;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC41NSAxMC4xNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCwuMzRsMTIuODUsOS4zYTMsMywwLDAsMCwzLjQ0LS4wNUwyOC41NSwwIi8+PC9nPjwvZz48L3N2Zz4=")
            center / contain no-repeat !important;
    }
}
</style>
